export default "__VITE_ASSET__DGQdNlg6__"